import { Element } from '../../../../../common/html/element'

const RatioSelectedCell = ({ val, backgroundColor }) => {
  return (
    <td
      rowSpan={2}
      style={{
        backgroundColor,
      }}
    >
      {val && <Element>{val}</Element>}
    </td>
  )
}

export default RatioSelectedCell
